import { datadogLogs } from '@datadog/browser-logs';
import { datadogRum } from '@datadog/browser-rum';
import { useEffect } from 'react';

export const GLOBAL_CONTEXT_PROPERTY_KEY = 'formContext';

export type FormsTargetMetadata = {
  patientCode?: string;
  consultationCode?: string;
  hashedEmail?: string;
};

export const useDatadogForFormsUserMetadata = (globalContext: FormsTargetMetadata) => {
  const { patientCode, consultationCode, hashedEmail } = globalContext;
  useEffect(() => {
    if (!patientCode && !consultationCode && !hashedEmail) {
      datadogRum.removeGlobalContextProperty(GLOBAL_CONTEXT_PROPERTY_KEY);
      datadogLogs.removeGlobalContextProperty(GLOBAL_CONTEXT_PROPERTY_KEY);
      return;
    }

    const globalContext = {
      patientCode,
      consultationCode,
      hashedEmail,
    };

    datadogRum.setGlobalContextProperty(GLOBAL_CONTEXT_PROPERTY_KEY, {
      ...globalContext,
    });
    datadogLogs.setGlobalContextProperty(GLOBAL_CONTEXT_PROPERTY_KEY, {
      ...globalContext,
    });
    return () => {
      datadogRum.removeGlobalContextProperty(GLOBAL_CONTEXT_PROPERTY_KEY);
      datadogLogs.removeGlobalContextProperty(GLOBAL_CONTEXT_PROPERTY_KEY);
    };
  }, [patientCode, consultationCode, hashedEmail]);
};
